export default {
  SET_PAGINATION(state, data) {
    state.pagination = data
  },
  SET_EMAILLOGS(state, documents) {
    state.emailLogs = documents
  },
}
